"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRequestor = exports.ApiRequestorError = void 0;
const axios_1 = __importDefault(require("axios"));
const logger_1 = require("@madbox/logger");
const object_extensions_1 = __importDefault(require("@madbox/object_extensions"));
class ApiRequestorError extends Error {
    constructor(message, errors, nativeError = null) {
        super(message);
        this.errors = errors;
        this.nativeError = nativeError;
    }
}
exports.ApiRequestorError = ApiRequestorError;
class ApiRequestor {
    constructor() {
        this._debug = false;
    }
    static get instance() {
        if (!ApiRequestor._instance)
            ApiRequestor._instance = new ApiRequestor();
        return ApiRequestor._instance;
    }
    static setDebug(debug) {
        return ApiRequestor.instance.setDebug(debug);
    }
    setDebug(debug) {
        this._debug = debug;
    }
    static setToken(token) {
        ApiRequestor.instance.setToken(token);
    }
    setToken(token) {
        this._token = token;
    }
    static removeToken() {
        ApiRequestor.instance.removeToken();
    }
    removeToken() {
        this._token = undefined;
    }
    static setTokenUpdateCallback(callback) {
        ApiRequestor.instance.setTokenUpdateCallback(callback);
    }
    setTokenUpdateCallback(callback) {
        this._tokenUpdateCallback = callback;
    }
    static setupService(serviceId, serviceToken) {
        ApiRequestor.instance.setupService(serviceId, serviceToken);
    }
    setupService(serviceId, serviceToken) {
        this._serviceId = serviceId;
        this._serviceToken = serviceToken;
    }
    static getService() {
        return ApiRequestor.instance._serviceId;
    }
    getService() {
        return this._serviceId;
    }
    static get(apiUrl, action, body, authentication) {
        return ApiRequestor.instance.get(apiUrl, action, body, authentication);
    }
    static post(apiUrl, action, body, authentication) {
        return ApiRequestor.instance.post(apiUrl, action, body, authentication);
    }
    static put(apiUrl, action, body, authentication) {
        return ApiRequestor.instance.put(apiUrl, action, body, authentication);
    }
    static delete(apiUrl, action, body, authentication) {
        return ApiRequestor.instance.delete(apiUrl, action, body, authentication);
    }
    static download(apiUrl, action, body, authentication) {
        return ApiRequestor.instance.download(apiUrl, action, body, authentication);
    }
    get(apiUrl, action, body, authentication) {
        return this.sendRequest('GET', apiUrl, action, body, authentication);
    }
    post(apiUrl, action, body, authentication) {
        return this.sendRequest('POST', apiUrl, action, body, authentication);
    }
    put(apiUrl, action, body, authentication) {
        return this.sendRequest('PUT', apiUrl, action, body, authentication);
    }
    delete(apiUrl, action, body, authentication) {
        return this.sendRequest('DELETE', apiUrl, action, body, authentication);
    }
    download(apiUrl, action, body, authentication) {
        return this.sendRequest('DOWNLOAD', apiUrl, action, body, authentication);
    }
    getDownloadUrl(apiUrl, action, body, authentication) {
        let url = this.getUrl(apiUrl, action, authentication);
        body = this.getAuthBody(body, authentication);
        delete body.token;
        const params = Object.keys(body).map((key) => key + '=' + encodeURIComponent(body[key]));
        if (params.length > 0)
            url += '?' + params.join('&');
        return url;
    }
    getUrl(apiUrl, action, authentication) {
        return apiUrl + '/' + authentication.entityId + '/' + authentication.type + '/' + action;
    }
    getAuthBody(body = {}, authentication) {
        body = object_extensions_1.default.clone(body);
        body.token = authentication.token || this._token;
        if (!(body.isAuthRequest && authentication.type === 'secure') && this._serviceId)
            body.serviceId = this._serviceId;
        if (!body.isAuthRequest && this._serviceToken)
            body.serviceToken = this._serviceToken;
        if (!body.isAuthRequest && body.serviceId && body.serviceToken)
            authentication.type = 'secure';
        if (authentication.secret)
            body.secret = authentication.secret;
        return body;
    }
    sendRequest(method, apiUrl, action, body = {}, authentication) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isFormData = typeof window !== 'undefined' && body instanceof window.FormData;
            let url = this.getUrl(apiUrl, action, authentication);
            const headers = {};
            if (isFormData) {
                headers['Content-Type'] = 'multipart/form-data';
                const authBody = this.getAuthBody({}, authentication);
                // puts token and everything in the FormData
                Object.keys(authBody).forEach((key) => {
                    if (authBody[key])
                        body.set(key, authBody[key]);
                });
                if (this._debug) {
                    logger_1.Logger.debug(`Sending form by ${method} request to ${url} as multipart/form-data with ${JSON.stringify(body, null, '\t')}`);
                }
            }
            else if (typeof body.append === 'function') {
                headers['Content-Type'] = 'multipart/form-data; boundary=' + body._boundary;
                const authBody = this.getAuthBody({}, authentication);
                // puts token and everything in the FormData
                Object.keys(authBody).forEach((key) => {
                    if (authBody[key])
                        body.append(key, authBody[key]);
                });
            }
            else {
                body = this.getAuthBody(body, authentication);
                url = this.getUrl(apiUrl, action, authentication);
                if (body.token)
                    headers.Authorization = 'Bearer ' + body.token;
                if (this._debug) {
                    logger_1.Logger.debug('Sending regular ' + method + ' request to ' + url + ' with' + JSON.stringify(body, null, '\t'), false);
                }
            }
            let response;
            // an error will be thrown if the request cannot be made, or if it returns an error code
            try {
                if (method === 'DOWNLOAD')
                    response = yield axios_1.default.get(url, { params: body, responseType: 'stream', headers });
                else if (method === 'GET')
                    response = yield axios_1.default.get(url, { params: body, headers });
                else if (method === 'POST')
                    response = yield axios_1.default.post(url, body, { headers, maxContentLength: Infinity, maxBodyLength: Infinity });
                else if (method === 'PUT')
                    response = yield axios_1.default.put(url, body, { headers });
                else if (method === 'DELETE')
                    response = yield axios_1.default.delete(url, { params: body, headers });
            }
            catch (e) {
                const errBody = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data;
                // if the body contains an errors array we create a custom error
                if ((errBody === null || errBody === void 0 ? void 0 : errBody.errors) && errBody.errors.length) {
                    throw new ApiRequestorError(`Error at ${method} ${url}`, errBody.errors, e);
                }
                // otherwise we throw the raw error
                else {
                    throw e;
                }
            }
            const responseBody = response === null || response === void 0 ? void 0 : response.data;
            const { status, data, errors } = responseBody;
            if (this._debug) {
                if (method === 'DOWNLOAD')
                    console.log('Got download stream for ' + url + ' : ' + response);
                else if (response)
                    console.log(response);
            }
            if (data === null || data === void 0 ? void 0 : data.token) {
                this._token = data.token;
                if (this._tokenUpdateCallback)
                    this._tokenUpdateCallback(this._token);
            }
            if (status === 0 || (errors === null || errors === void 0 ? void 0 : errors.length)) {
                throw new ApiRequestorError(`Error at ${method} ${url}`, errors);
            }
            return data || responseBody;
        });
    }
}
exports.ApiRequestor = ApiRequestor;
